import {
  ReactSelectController,
  Text,
  TextController,
} from "@pushpress/shared-components";
import { type Control } from "react-hook-form";
import { clientStatusOptions } from "../PlanDrawer.utils";
import PlanCategorySelect from "../../../../components/controllers/PlanCategorySelect";
import { PlanForm } from "../PlanDrawer.types";

interface BasicSectionProps {
  control: Control<PlanForm>;
}

const BasicSection = (props: BasicSectionProps) => {
  const { control } = props;

  return (
    <div>
      <Text component="h2" variant="heading-5" weight="600" color="wolf-800">
        Basic info
      </Text>
      <Text variant="body-md" color="wolf-600" className="mt-1">
        Set basic info about this plan
      </Text>
      <TextController
        control={control}
        name="name"
        label="Name"
        className="mt-3"
        required
      />
      <ReactSelectController
        control={control}
        name="clientStatus"
        label="Client status"
        required
        helperText="What should be the status of clients that have this plan?"
        options={clientStatusOptions}
      />
      <PlanCategorySelect
        control={control}
        name="planCategory"
        label="Category"
        helperText="Used for reporting, and organizing your plans"
        className="mt-3 mb-4"
        required
      />
    </div>
  );
};

export default BasicSection;
